import { API } from 'aws-amplify';
import axios from 'axios'

export const decryptParams = async (params) => {
  const { account, data } = params;
  const request = { queryStringParameters: { type: 'decrypt' }, body: { accountUuid: account, data } };
  return API.post('RecognitionAPI', '/parametersService', request);
};

export const encryptParams = async (params) => {
  const { account, names, lastNames, documentType, documentNumber, idExpeditionDate } = params;

  const data = names + '|' + lastNames + '|' + documentType + '|' +
      documentNumber + '|' + idExpeditionDate + '|' + new Date();

  const request = { queryStringParameters: { type: 'encrypt' }, body: { accountUuid: account, data } };
  return API.post('RecognitionAPI', '/parametersService', request);
};


export const shortUrl = async (url) => {
  return axios.get('https://api.shrtco.de/v2/shorten', {
    params: { url }
  })
}
